/**
 * Schema of Endereco
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {cep} from 'simpli-web-sdk'
import Endereco from '@/model/resource/Endereco'

export default (model: Endereco): Schema => ({
  idEnderecoPk: {
    content: model.idEnderecoPk,
    editable: false,
  },

  cep: {
    content: cep(model.cep),
    input: InputType.CEP,
    meta: {
      required: true,
    },
  },
  complemento: {
      content: model.complemento,
      input: InputType.TEXT,
      meta: {
          maxlength: '255',
      },
  },
  pais: {
      content: model.pais,
      input: InputType.TEXT,
      meta: {
          maxlength: '255',
      },
  },

  logradouro: {
    content: model.logradouro,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  nro: {
    content: model.nro,
    input: InputType.MASK,
    meta: {
      required: true,
      mask: '##########',
    },
  },

  bairro: {
    content: model.bairro,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  cidade: {
    content: model.cidade,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  uf: {
    content: model.uf,
    input: InputType.SELECT,
    model: 'ufResource',
    meta: {
      required: true,
    },
  },

  latitude: {
    content: model.latitude,
    editable: false,
  },

  longitude: {
    content: model.longitude,
    editable: false,
  },
})
